import { SELECT_MULTIPLE_ELEMENTS, SELECT_ALL_ELEMENTS, SET_KEY_ELEMENT } from "../../actions";
import ItemTypes from "../../constants/ItemTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_MULTIPLE_ELEMENTS:
      if (action.payload.itemType === ItemTypes.TEXT) {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.layer_id === action.payload.layerId) {
              layer.text_elements = layer.text_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    const toggleSelected = !element.is_selected;
                    return {
                      ...element,
                      is_selected: toggleSelected,
                      is_key_element: toggleSelected ? element.is_key_element : false,
                    };
                  } else {
                    return {
                      ...element,
                    };
                  }
                },
              );
              layer.image_elements = layer.image_elements.map((element) => {
                return {
                  ...element,
                };
              });
            }
            return layer;
          }),
        };
      } else if (action.payload.itemType === ItemTypes.IMAGE) {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.layer_id === action.payload.layerId) {
              layer.image_elements = layer.image_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    const toggleSelected = !element.is_selected;
                    return {
                      ...element,
                      is_selected: toggleSelected,
                      is_key_element: toggleSelected ? element.is_key_element : false,
                    };
                  } else {
                    return {
                      ...element,
                    };
                  }
                },
              );
              layer.text_elements = layer.text_elements.map((element) => {
                return {
                  ...element,
                };
              });
            }
            return layer;
          }),
        };
      }
      break;

    case SELECT_ALL_ELEMENTS:
      if (action.payload) {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };

            layer.text_elements = layer.text_elements.map((element) => {
              return {
                ...element,
                is_selected: true,
              };
            });
            layer.image_elements = layer.image_elements.map((element) => {
              return {
                ...element,
                is_selected: true,
              };
            });
            return layer;
          }),
        };
      } else {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };

            layer.text_elements = layer.text_elements.map((element) => {
              return {
                ...element,
                is_selected: false,
                is_key_element: false,
              };
            });
            layer.image_elements = layer.image_elements.map((element) => {
              return {
                ...element,
                is_selected: false,
                is_key_element: false,
              };
            });

            return layer;
          }),
        };
      }

    case SET_KEY_ELEMENT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          if (old_layer.layer_id === action.payload.layerId) {
            return {
              ...old_layer,
              text_elements: old_layer.text_elements.map((element) => ({
                ...element,
                is_key_element: element.id === action.payload.id,
              })),
              image_elements: old_layer.image_elements.map((element) => ({
                ...element,
                is_key_element: element.id === action.payload.id,
              })),
            };
          }
          return old_layer;
        }),
      };

    default:
      return state;
  }
}
